import axios from "axios";
import Cookies from "js-cookie";
import Config from "../Constants/Config";

const apiClient = () => {
  const instance = axios.create({
    // baseURL: "https://api-dev.zabali.co/",
    baseURL: Config.baseURL,
    // baseURL: "https://nf17zh4r-9034.inc1.devtunnels.ms",
    // baseURL:"https://zf2cq129-9034.inc1.devtunnels.ms/",
    timeout: 60000,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });

  instance.interceptors.request.use(
    (config) => {
      const token = Cookies.get("authCode"); // Use `js-cookie` if the cookie is accessible
      if (token) {
        config.headers.Authorization = token;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // instance.interceptors.response.use(
  //   (response) => response,
  //   (error) => {
  //     if (error.response && error.response.status === 401) {
  //       const currentPath = window.location.pathname;

  //       // Prevent infinite redirect loop on login page
  //       if (currentPath !== "/login") {
  //         Cookies.remove("authCode");
  //         window.location.href = "/login";
  //       }
  //     }

  //     return Promise.reject(error);
  //   }
  // );

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        const currentPath = window.location.pathname;
        // List of public paths where redirect should NOT happen
        const publicPaths = [
          "/login",
          "/",
          "/about-us",
          "/contact-us",
          "/inquiry-form",
          "/privacy-policy",
          "/terms-and-conditions",
        ];

        // const isPublic = publicPaths.includes(currentPath);
        // const isPublic = publicPaths.some((path) =>
        //   currentPath.startsWith(path)
        // );
        const isPublic = publicPaths.some((path) => {
          if (path === "/") return currentPath === "/";
          return currentPath.startsWith(path);
        });

        if (!isPublic) {
          Cookies.remove("authCode");
          window.location.href = "/login";
        }
      }

      return Promise.reject(error);
    }
  );

  return instance;
};

export { apiClient };
